import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
import HistoricChatModal from "../../../ReportClosed/Modals/HistoricChatModal";

// Semantic
// import { Popup, Icon } from "semantic-ui-react";

// Lodash
// import { isEmpty, trim, slice, replace, find } from "lodash";

// Utils
import dataHandler from "@Utils/dataHandler";

// Styles
import styles from "./styles.module.css";

const Detalladas = ({ dispatch, userName, companyName, onOpenFilterModal, appliedFilters = {} }) => {
	const defaultParams = {
		page: 1,
		orderKey: appliedFilters.orderKey || "group.name",
		orderDir: appliedFilters.orderDir || "asc",
		rows: 20,
	};
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [lastParams, setLastParams] = useState(defaultParams);
	const [selectedChatData, setSelectedChatData] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);

	useEffect(() => {
		const mergedParams = { ...defaultParams, ...appliedFilters };

		(async () => {
			try {
				const response = await dataHandler({
					dispatch,
					method: "GET",
					url: "/reports/combined/detailed",
					params: mergedParams,
				});

				const transformedItems = response.items.map((item) => {
					return {
						...item,
						tags: item.tags || [],
						group: item.group || {},
					};
				});

				setFilteredItems(transformedItems);
				setFilteredCount(response.count);
				setLastParams(mergedParams);
			} catch (error) {
				setFilteredItems([]);
				setFilteredCount(0);
			}
		})();
	}, [appliedFilters]);

	const handlerData = async (params = defaultParams, printable) => {
		const mergedParams = {
			...appliedFilters,
			...params,
			fields: "closeDate,group.name,user.fullName,tags.name,contact.phone,contact.name,createdDate,channel.label",
		};

		const data = await dataHandler({
			method: "GET",
			dispatch,
			url: "/reports/combined/detailed",
			params: mergedParams,
		});

		const transformedItems = data.items.map((item) => {
			return {
				...item,
				tags: item.tags || [],
				group: item.group || {},
			};
		});

		if (printable) {
			setFilteredPrintData(transformedItems);
		} else {
			setFilteredItems(transformedItems);
			setFilteredCount(data.count);
			setLastParams(mergedParams);
		}
	};

	const handleRefreshData = () => {
		handlerData(lastParams);
	};

	const renderTopButtons = () => {
		const buttons = [
			{
				icon: "filter",
				className:
					Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0
						? styles.filterButtonActive
						: styles.filterButton,
				onClick: onOpenFilterModal,
				content: Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0 ? "Filtrando" : "",
				label: Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0 ? "Filtrando" : "",
				showLabel: true,
				componentType: "button",
			},
			{
				icon: "refresh",
				className: styles.refreshButton,
				onClick: handleRefreshData,
			},
		];

		const filters = typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {};
		const dateRange = filters.createdDate || filters.closeDate;
		if (dateRange) {
			const formatDate = (d) => {
				if (!d) return "";
				const parts = d.split("-");
				if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
				return d;
			};
			const [start, end] = dateRange.split(",");
			let value = formatDate(start);
			const today = new Date();
			const currentEnd =
				end || `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
			if (currentEnd && start !== currentEnd) value += ` al ${formatDate(currentEnd)}`;

			buttons.push({
				componentType: "Label",
				title: "Fecha:",
				value,
			});
		}

		return buttons;
	};

	const handleChatClick = (item) => {
		setSelectedChatData(item);
		setIsModalOpen(true);
	};

	const handleChatKeyDown = (e, item) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			setSelectedChatData(item);
			setIsModalOpen(true);
		}
	};

	const columns = [
		{
			label: "Chat ID",
			key: "id",
			format: "string",
			headerPosition: "center",
			dataPosition: "center",
			width: 1,
			render: (item) => {
				const id = item.chatId || item.id;
				return (
					<span
						className={styles.clickableChatId}
						role="button"
						tabIndex={0}
						onClick={() => {
							return handleChatClick(item);
						}}
						onKeyDown={(e) => {
							return handleChatKeyDown(e, item);
						}}>
						{id}
					</span>
				);
			},
		},
		{ label: "Grupos", key: "group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
		{
			label: "Usuario",
			key: "user.fullName",
			format: "string",
			headerPosition: "center",
			dataPosition: "left",
			width: 1,
		},
		{ label: "Contacto", key: "contact.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
		{ label: "Teléfono", key: "contact.phone", format: "phone", headerPosition: "center", dataPosition: "center", width: 1 },
		{ label: "F. Inicio", key: "createdDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
		{ label: "F. Cierre", key: "closeDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
		{
			label: "Tiempo Total",
			key: "createdDate",
			endDateKey: "closeDate",
			format: "timeBetween",
			headerPosition: "center",
			dataPosition: "left",
			width: 1,
		},
		{
			label: "Tab",
			key: "closeTab",
			format: "string",
			headerPosition: "center",
			dataPosition: "left",
			width: 1,
		},
		{
			label: "Estado",
			key: "closeState",
			format: "string",
			headerPosition: "center",
			dataPosition: "left",
			width: 1,
		},
		{
			label: "Etiquetas",
			key: "tags.name[]?",
			format: "arrayTruncate",
			headerPosition: "center",
			canSort: false,
			dataPosition: "left",
			width: 1,
		},
		{
			label: "Canal",
			key: "channel.label",
			format: "string",
			headerPosition: "center",
			dataPosition: "left",
			width: 1,
		},
		{
			label: "Plataforma",
			key: "channel.platform.name",
			format: "string",
			headerPosition: "center",
			dataPosition: "center",
			width: 1,
		},
		/* {
			label: "Origen",
			key: "origin",
			format: "string",
			headerPosition: "center",
			dataPosition: "center",
			width: 1,
		}, */
	];
	return (
		<div className={styles.container}>
			<div className={styles.containerTableGroup}>
				<div className={styles.tableGroupList}>
					<IkTable
						data={filteredItems}
						columns={columns}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						print={{
							printHeader: {
								company: companyName,
								title: "Detalladas",
								user: userName,
							},
						}}
						searcher={{
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
					/>
				</div>
			</div>
			{isModalOpen && (
				<HistoricChatModal
					open={isModalOpen}
					onClose={() => {
						setIsModalOpen(false);
						setSelectedChatData(null);
					}}
					chatData={selectedChatData}
					companyName={companyName}
					userName={userName}
				/>
			)}
		</div>
	);
};

function mapStateToProps({ user, company }) {
	return {
		userName: user.name,
		companyName: company.name,
	};
}

Detalladas.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	onOpenFilterModal: PropTypes.func,
	appliedFilters: PropTypes.object,
};

export default connect(mapStateToProps)(Detalladas);
